import { MonitoringPipelineGoliveDetailItem } from '@/libs/fleet-api/services/monitoring-pipeline-golive';
import { Modal, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { FC } from 'react';

interface MonitoringPipelineGoliveDetailModalProps {
	visible: boolean;
	onClose: () => void;
	data: MonitoringPipelineGoliveDetailItem[];
	title?: string;
}

const MonitoringPipelineGoliveDetailModal: FC<
	MonitoringPipelineGoliveDetailModalProps
> = ({ visible, onClose, data, title }) => {
	const formatCurrency = (value?: number) => {
		return value?.toLocaleString('id-ID') ?? '-';
	};

	const formatDate = (value?: string) => {
		return value ? dayjs(value).format('DD/MM/YYYY') : '-';
	};

	const columns: ColumnsType<MonitoringPipelineGoliveDetailItem> = [
		{
			title: 'No. PO',
			dataIndex: 'purchaseOrderNo',
			key: 'purchaseOrderNo',
		},
		{
			title: 'No. Simulasi',
			dataIndex: 'creditSimulationNo',
			key: 'creditSimulationNo',
		},
		{
			title: 'NTF',
			dataIndex: 'ntfAmount',
			key: 'ntfAmount',
			align: 'right',
			render: (value) => formatCurrency(value),
		},
		{
			title: 'Unit',
			dataIndex: 'unit',
			key: 'unit',
			align: 'center',
		},
		{
			title: 'Tanggal Terbit PO',
			dataIndex: 'createdAt',
			key: 'createdAt',
			render: (value) => formatDate(value),
		},
		{
			title: 'Tanggal PO Expired',
			dataIndex: 'releaseDate',
			key: 'releaseDate',
			render: (value) => formatDate(value),
		},
		{
			title: 'Status PO',
			dataIndex: 'originalStatus',
			key: 'originalStatus',
		},
		{
			title: 'Plafon Type',
			dataIndex: 'plafonType',
			key: 'plafonType',
		},
		{
			title: 'Step',
			dataIndex: 'step',
			key: 'step',
		},
	];

	return (
		<Modal
			title={`Details for ${title || 'FBDH'}`}
			open={visible}
			onCancel={onClose}
			footer={null}
			width={1200}
			centered
		>
			<Table
				columns={columns}
				dataSource={data}
				pagination={{ pageSize: 10 }}
				rowKey={(record) =>
					record.purchaseOrderNo ||
					record.creditSimulationNo ||
					Math.random().toString()
				}
				scroll={{ x: 'max-content' }}
			/>
		</Modal>
	);
};

export default MonitoringPipelineGoliveDetailModal;
